var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"close-on-click-modal":false,"title":_vm.title,"visible":_vm.showDownload,"width":"90%"},on:{"close":_vm.dialogClose}},[(_vm.showDownload)?[_c('cc-table',{attrs:{"loadData":true,"config":_vm.tableLog,"params":_vm.paramslog,"refeshParams":_vm.refeshParams}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }